import { emptySplitApi } from "./empty-split-api";

export interface ReferralInput {
  first_name: string;
  last_name: string;
  phone?: string;
  email?: string;
  company?: string;
  website?: string;
  can_mention?: boolean;
}

export const referralsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    sendReferral: builder.mutation<void, ReferralInput>({
      query: (body) => ({
        url: `/referrals/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useSendReferralMutation } = referralsApi;
